// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* navbar height used to offset page content and sticky action bars */
  --navbar-height: 86px;
}

/* Ensure the document and app root fill the viewport and remove default margins.
   Allow page scrollbars by default; the Map page will still hide them via its own CSS. */
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: auto; /* allow page scrollbars for non-map pages */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.App {
  text-align: center;
  /* offset content so fixed navbar doesn't cover page content */
  padding-top: var(--navbar-height);
  min-height: 100vh;       /* ensure App is at least viewport height but can grow */
  box-sizing: border-box;
  overflow: visible;       /* let the document (body) show the scrollbar */
}

.App-logo {
    max-height: 56px;
    width: auto;
    object-fit: contain;
    pointer-events: none;
}

/* small-screen tweak */
@media (max-width: 576px) {
    :root {
        --navbar-height: 72px;
    }

    .App-logo {
        height: 36px;
    }
}

/* sticky elements that need to sit below the fixed navbar */
.sticky-action {
  top: var(--navbar-height);
}

/* keep the logo animation optional for reduced-motion prefs */
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,qBAAqB;AACvB;;AAEA;yFACyF;AACzF;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc,EAAE,4CAA4C;EAC5D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,iCAAiC;EACjC,iBAAiB,QAAQ,wDAAwD;EACjF,sBAAsB;EACtB,iBAAiB,QAAQ,+CAA+C;AAC1E;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,uBAAuB;AACvB;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\r\n  /* navbar height used to offset page content and sticky action bars */\r\n  --navbar-height: 86px;\r\n}\r\n\r\n/* Ensure the document and app root fill the viewport and remove default margins.\r\n   Allow page scrollbars by default; the Map page will still hide them via its own CSS. */\r\nhtml, body, #root {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: auto; /* allow page scrollbars for non-map pages */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n  /* offset content so fixed navbar doesn't cover page content */\r\n  padding-top: var(--navbar-height);\r\n  min-height: 100vh;       /* ensure App is at least viewport height but can grow */\r\n  box-sizing: border-box;\r\n  overflow: visible;       /* let the document (body) show the scrollbar */\r\n}\r\n\r\n.App-logo {\r\n    max-height: 56px;\r\n    width: auto;\r\n    object-fit: contain;\r\n    pointer-events: none;\r\n}\r\n\r\n/* small-screen tweak */\r\n@media (max-width: 576px) {\r\n    :root {\r\n        --navbar-height: 72px;\r\n    }\r\n\r\n    .App-logo {\r\n        height: 36px;\r\n    }\r\n}\r\n\r\n/* sticky elements that need to sit below the fixed navbar */\r\n.sticky-action {\r\n  top: var(--navbar-height);\r\n}\r\n\r\n/* keep the logo animation optional for reduced-motion prefs */\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
